module.exports = __webpack_public_path__ + "static/img/zg_button.a6a99ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zg_button.png
// module id = AZz2
// module chunks = 3